import React, { FC, useState } from 'react';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { useUser } from '../../user/useUser';
import { ExcerptTitle } from '../../components/excerpt/title/ExcerptTitle';

type Props = {
  decision: {
    visited: boolean;
    url: string;
    position?: number;
    titre: string;
  };
  index: number;
  source: string;
  sourcePage: string;
  additionalQueryParams?: { [s: string]: string } | null;
  onDecisionTitleClicked?: Function;
};

export const DecisionHeaderTitle: FC<Props> = ({
  decision,
  source,
  sourcePage,
  additionalQueryParams = {},
  index,
  onDecisionTitleClicked = () => {},
}) => {
  const [visited, setVisited] = useState(decision.visited);
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (accessPremium) {
      setVisited(true);
      onDecisionTitleClicked(event);
    } else {
      openRestrictedModal({ source });
    }
  };

  const href = buildUrlWithParameters(decision.url, {
    source,
    sourcePage,
    ...additionalQueryParams,
  });

  const linkProps = accessPremium ? { href } : {};

  return (
    <ExcerptTitle
      visited={visited}
      id={`excerpt_title_${index}`}
      onClick={onClick}
      position={decision.position}
      {...linkProps}
    >
      <span dangerouslySetInnerHTML={{ __html: decision.titre }} />
    </ExcerptTitle>
  );
};
